import { PaymentMethod } from '@models/order/request';

export const PaymentMethodKr: Record<PaymentMethod, string> = {
  PREPAID_CARD: '선불카드',
  CREDIT_CARD: '신용카드',
  NAVER_PAY: '네이버페이',
  KAKAO_PAY: '카카오페이',
  TOSS_PAY: '토스페이',
  APPLE_PAY: '애플페이',
  PAYCO: '페이코',
};
